import DataExtractionFieldBase from './DataExtractionFieldBase';

export const __typename = 'DataExtractionFieldMultipleSelectDto';
export default class DataExtractionFieldMultipleSelect extends DataExtractionFieldBase {
  constructor(data = {}) {
    super({
      ...data,
      __typename,
    });

    this.multipleChoiceOptions = data.multipleChoiceOptions ?? [];
    this.otherOption = data.otherOption ?? false;
  }
}
